import React from 'react'
import Tutorlanding from '../../Components/tutor/Tutorlanding'

function Landingfortutor() {
  return (
    <div>
      <Tutorlanding/>
    </div>
  )
}

export default Landingfortutor
